import script from "./TopBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=ts"

import "./TopBar.vue?vue&type=style&index=0&id=d77fac8a&lang=scss"
import "./TopBar.vue?vue&type=style&index=1&id=d77fac8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d77fac8a"]])

export default __exports__